import React, { useState } from 'react';
import { Button, Pagination } from 'antd';
import { DownloadExcel } from '../../../common/downloadExcel/DownLoadExcel';
import ExportPdf from '../../../common/exportPdf/ExportPdf';
import { baseUrlImage } from '../../../baseUrl';
import { DownloadOutlined } from '@ant-design/icons';
import { Formik, Field } from "formik";
import CustomInputField from '../../../common/CustomInputField';
import Select from "react-select";
import { Form, Modal } from "react-bootstrap";
import * as Yup from "yup";
import InputGroup from 'react-bootstrap/InputGroup';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { FaEye } from 'react-icons/fa';
import { payoutBeneficiaryApproval } from '../../../api/login/Login';
import { toast } from "react-toastify";

const status = {
  1: "Pending",
  2: "Approved",
  3: "Rejected",
};

function PayoutBeneFiciaryReportsList({ setReset, setLoading ,  onChangeVal, aepsData , page, count }) {
   
    const [isModalOpen, setIsModalOpen] = useState(false);
     const [openPopup, setOpenPopup] = useState(false);
      const [selectedUser, setSelectedUser] = useState({});
      // const [steps, setSteps] = useState(1);
    // const showModal = (value) => {
        
    //     if(value === 1)
    //     {

    //       setIsModalOpen(true);  
    //     }
    //   };
    
    //   const handleOk = () => {
    //     //  console.log("Ok")
    //      window.open('https://idp.axisbank.co.in/mib/Welcome#!', '_blank');
    //     setIsModalOpen(false);
    //   };
    
    //   const handleCancel = () => {
    //     setIsModalOpen(false);
    //   };




    //    const handleClose = () => {
    //       setOpenPopup(false);
    //     };
      
        const handleOpenPopup = (value) => {
          console.log(value , "value")
        if(value.status === 1)
        {
       setSelectedUser(value);
          setStatusUpdate({
             username : value?.user_id?.name ,
            beni_id : value?._id,
            bank_account_name: value?.bank_account_name ||'',
            status: value?.status || "",
            bank_account_number: value?.bank_account_number || "",
            bank_ifsc: value?.bank_ifsc ||'',
            bank_name: value?.bank_name||'',
            bank_proof: value?.bank_proof ||'',
          });
          // setSteps(1);
          setOpenPopup(true);
        }
      
        };

         const handleClose = () => {
    setOpenPopup(false);
 
  };
        
      
        const stepOneValidationSchema = Yup.object().shape({
          status: Yup.string().required("Status is required"),
        });
        
      
      
  
      
        const [statusUpdate, setStatusUpdate] = useState({
        bank_account_name:  '',
        username :'',
        beni_id : '',
            status:  "",
            bank_account_number:  "",
            bank_ifsc: '',
            bank_name: '',
            bank_proof: '',
        });
      
      
     
        
      
     
    return (
        <>
           
            <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b> Payout BeneFiciary Report List</b></h4>
                                        <div className='d-flex'>
                                            <ExportPdf />
                                            <button className='btn btn-primary border border-white' onClick={DownloadExcel}> <DownloadOutlined /> Download Excel</button>
                                        </div>
                                    </div>
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="table-to-xls" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
                                            <thead>

                                                <tr role="row">
                                                <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Serial Number					</th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Date and Time
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        User Name					</th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Bank Acc Number
                                                    </th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Bank Acc Name
                                                    </th>
                                                    {/* <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Bank ID
                                                    </th> */}

                                                    {/* <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Type 				</th> */}


                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Bank Name
                                                    </th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Bank IFSC
                                                    </th>
                                                    {/* <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Bank Branch  					</th> */}

                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Bank Proof
                                                    </th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Mobile No
                                                    </th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Approval Type
                                                    </th>
                                                    <th className="sorting_asc" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Employee ID: activate to sort column descending" style={{ width: '122.312px' }}>
                                                        Beneficiary Id
                                                    </th>
                                                    <th className="sorting" tabIndex={0} aria-controls="empoloyees-tblwrapper" rowSpan={1} colSpan={1} aria-label="Status: activate to sort column ascending" style={{ width: '96.125px' }}>
                                                        Status				</th>


                                                </tr>
                                            </thead>
                                            <tbody>

                                                {aepsData?.data && aepsData.data.length > 0 ? (
                                                    aepsData.data.map((item, i) => (
                                                        <tr key={item._id} role="row" className="odd" >
                                                              <td>{(i + 1) + count * page}</td>
                                                              <td>{new Date(item?.createdAt).toLocaleString()}</td>
                                                            <td>{item?.user_id?.name}</td>
                                                            <td>{item?.bank_account_number}</td>
                                                            <td>{item?.bank_account_name}</td>
                                                            {/* <td>{item?.bank_id}</td> */}
                                                            {/* <td>{item?.account_type}</td> */}

                                                            <td>{item?.bank_name}</td>

                                                            <td>{item?.bank_ifsc}</td>
                                                            {/* <td>{item?.bank_branch}</td> */}
                                                            <td>
                                                                {item?.bank_proof ? (<img src={`${baseUrlImage}${item?.bank_proof}`} alt="bank proof" />) : "Bank Proof Not Found"}
                                                            </td>
                                                            <td>{item?.mobile_number}</td>
                                                            <td> <span className="badge badge-success text-light border-0" style={{ backgroundColor: `${item?.approval_type === "Self" ? 'blue' : '#bc3922ab'}`, fontSize: `${item?.approval_type === "Vendor" ? '0.8rem' : ''}` }}>{item?.approval_type === "Self" ? 'SELF' : 'VENDOR'}</span>
                                                            </td>
                                                            <td>{item?._id}</td>
                                                            <td><span
                                                                className={`${item?.status === 1 ? "btn btn-warning w-100" :
                                                                    item?.status === 2 ? "btn btn-success w-100" :
                                                                        item?.status === 3 ? "btn btn-danger w-100" :
                                                                            ""
                                                                    }`}
                                                                    onClick={()=>handleOpenPopup(item)}   
                                                            >
                                                                {item?.status === 1 && 'Pending'}
                                                                {item?.status === 2 && 'Approved'}
                                                                {item?.status === 3 && 'Rejected'}
                                                            </span></td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr role="row" className="odd">
                                                        <td colSpan="10" style={{ textAlign: "center" }}><strong>No Data Found</strong></td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>


                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                    Total {aepsData?.totalCount} entries
                                </div>
                                <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                    <Pagination
                                        /* showSizeChanger
                                        onShowSizeChange={''} */

                                        // defaultCurrent={1}
                                        current={page+1}
                                        onChange={onChangeVal}
                                        total={aepsData?.totalCount}
                                    />
                                </div>
                            </div>
                            {/* <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                {aepsData ? <h4> Total Amount : {aepsData?.totalAmount} </h4> : ""}
                            </div> */}
                        </div>

                    </div>
                </div>
            </section>

            {/* <Modal  open={isModalOpen} okText={'Yes'} cancelText={'No'} onOk={handleOk} onCancel={handleCancel}>
        <p>This beneficiary needs to be verified first on Axis Bank's portal.</p>
        <p>Do you want to proceed?</p>
      </Modal> */}

       <Modal
              show={openPopup}
              onHide={handleClose}
              className="dilog-box newcuss"
              id="dilog-box"
            >
              <Modal.Header closeButton>
                <span style={{ fontSize: "20px", color: "var(--nav)" }}>
                  <b>Approval User Payout Bank</b>
                </span>
              </Modal.Header>
      
              <Modal.Body style={{ paddingTop: "0px" }}>
              {/* <h4 className='py-2 px-2 text-primary'>User Wallet Balance : <span>
                          {selectedUser?.payin_wallet || 0}
                          </span> </h4>  */}
        <Formik
          initialValues={statusUpdate}
          enableReinitialize
          validationSchema={stepOneValidationSchema}
          onSubmit={async(values) => {
              let body = {
                beni_id : values?.beni_id,
                status : values?.status
              }
              setLoading(true)
                try {
                  let res = await payoutBeneficiaryApproval(body)
                   if(res?.error === false)
                   {
                       toast.success(res?.message, { position: "top-center" });
                       
                   }
                   else {
                      toast.error(res?.message, { position: "top-center" });
                   }
                   setReset((pre)=>!pre)
                   setOpenPopup(false)
                   setIsModalOpen(false)
                } catch (error) {
                  
                } finally {
                  setLoading(false)
                }
            
              
            
          }}
        >
          {({ values, handleChange, handleSubmit, errors, touched }) => (
            <Form onSubmit={handleSubmit} className="cusformsnew">
              
                <>
                  <div className="row mt-4">
                     <div className="col-xl-6 mb-3">
                      <Field
                        as={CustomInputField}
                        type="text"
                        name="username"
                        placeholder="User Name"
                        readOnly
                        
                      />
                    </div>
                    <div className="col-xl-6 mb-3">
                      <Field
                        as={CustomInputField}
                        type="text"
                        name="bank_name"
                        placeholder="Bank Name"
                        readOnly
                        
                      />
                    </div>
                     <div className="col-xl-6 mb-3">
                      <Field
                        as={CustomInputField}
                        type="text"
                        name="bank_ifsc"
                        placeholder="IFSC Code"
                        readOnly
                        
                      />
                    </div>
                    <div className="col-xl-6 mb-3">
                      <Field
                        as={CustomInputField}
                        type="text"
                        name="bank_account_name"
                        placeholder=" Account Holder Name"
                        readOnly
                        
                      />
                    </div>
                      <div className="col-xl-6 mb-3">
                      <Field
                        as={CustomInputField}
                        type="text"
                        name="bank_account_number"
                        placeholder="Bank Account Number"
                        readOnly
                        
                      />
                    </div>

                    
      
                    <div className="col-xl-6 mb-3">
                      <select
                        className={`form-select ${touched.status && errors.status ? "is-invalid" : ""}`}
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                      >
                        <option value="">Select Status</option>
                        {Object?.entries(status)?.map(([key, value]) => (
                          <option key={key} value={key}>{value}</option>
                        ))}
                      </select>
                      {touched.status && errors.status && (
                        <div className="invalid-feedback">{errors.status}</div>
                      )}
                    </div>

                    <div className='col-xl-6 mb-3'>
                      <div className="card" onClick={()=>setIsModalOpen(true)}>
                        <div className="" style={{cursor:'pointer'}}>
                                                                                                   <picture>
                                                                                                        <img  width="100%" src={`${baseUrlImage}${statusUpdate?.bank_proof}`} />
                                                                                                   </picture>
                                                                                               </div>
                                                                                              
                      </div>
                    </div>
      
             
      
                  </div>
      
                  <div className="text-end">
                    <Button type="primary" htmlType="submit">
                      Update
                    </Button>
                  </div>
                </>
              
            </Form>
          )}
        </Formik>
      </Modal.Body>
      
            </Modal>


            {/* // Image Show PopUp  */}
  <Modal
              show={isModalOpen}
              onHide={()=>setIsModalOpen(false)}
              className="dilog-box newcuss"
              id="dilog-box"
            >

           
              <Modal.Header closeButton>
                <Modal.Title>{'Bank Proof'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
   
        <img src={`${baseUrlImage}${statusUpdate?.bank_proof}`} style={{ width: '100%', height: 'auto' }} alt="Document" />
    

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={()=>setIsModalOpen(false)}>
                    Close
                </Button>
            </Modal.Footer>
 </Modal>
        </>
    )
}

export default PayoutBeneFiciaryReportsList
